import { WorkflowHeader } from '@/components/workflow/WorkflowHeader'
import { WorkflowStepCard } from '@/components/workflow/WorkflowStepCard'
import { WorkflowStepNavigation } from '@/components/workflow/WorkflowStepNavigation'
import { useSoftwareAssuranceWorkflow } from '@/hooks/workflow/useSoftwareAssuranceWorkflow'

export function SoftwareAssuranceWorkflowPage() {
  const workflow = useSoftwareAssuranceWorkflow()

  return (
    <div className="space-y-6 animate-fade-in">
      <WorkflowHeader />

      <div className="grid grid-cols-1 xl:grid-cols-[280px_1fr] gap-6">
        <WorkflowStepNavigation workflow={workflow} />
        <WorkflowStepCard workflow={workflow} />
      </div>
    </div>
  )
}
